import styled from "@emotion/styled";

import { fontMerriweather } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  position: relative;

  display: flex;
  gap: 12px;

  padding: 12px;

  border: 1px solid #2c4692;
  border-radius: 4px;

  background: #ffffff;
`;

export const StyledEntityLink = styled(EntityLink)`
  flex: 1;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 140%;
`;

export const Headline = styled.div``;

export const StyledCoverEntityLink = styled(EntityLink)`
  inline-size: 60px;
  block-size: 60px;
`;

export const CoverImage = styled.div`
  position: relative;
  aspect-ratio: 1/1;

  inline-size: 100%;
  block-size: 100%;
`;
